import styled from 'styled-components'

export const ProductsContainer = styled.div`
  background-color: #E5E5F2;
  border-radius: var(--border-radius);
  padding: 20px;
`